/*
 * CircuitCreate Messages
 *
 * This contains all the text for the CircuitCreate component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.CircuitCreate.title',
    defaultMessage: 'New Circuit',
  },
  saveButton: {
    id: 'app.containers.CircuitCreate.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.CircuitCreate.saveSuccess',
    defaultMessage: 'Circuit has been successfully created.',
  },
  saveFailure: {
    id: 'app.containers.CircuitCreate.saveFailure',
    defaultMessage: 'Error. The circuit could not be created.',
  },
});
